export class QuestionBase<T> {
  value: T;
  key: string;
  label: string;
  required: boolean;
  order: number;
  controlType: string;
  disabled: boolean;
  readonly: boolean;
  customClasses: string[];
  display: boolean;
  conditionnalRules: any[];

  constructor(
    options: {
      value?: T;
      key?: string;
      label?: string;
      required?: boolean;
      order?: number;
      controlType?: string;
      disabled?: boolean;
      readonly?: boolean;
      customClasses?: string[];
      display?: boolean;
      conditionnalRules?: any[];
    } = {}
  ) {
    this.value = options.value;
    this.key = options.key || '';
    this.label = options.label || '';
    this.required = !!options.required;
    this.order = options.order === void 0 ? 1 : options.order;
    this.controlType = options.controlType || '';
    this.disabled = options.disabled || false;
    this.readonly = options.readonly || false;
    this.customClasses = options.customClasses || [];
    this.display = options.display || true;
    this.conditionnalRules = options.conditionnalRules || undefined;
  }
}
